export enum PanelType {
	TEMPLATES = "Templates",
	BACKGROUND = "Background",
	FONTSELECTOR = "FontSelector",
	TEXTFILL = "TextFill",
	TEXTHIGHLIGHTER = "TextHighlighter",
	SHAPEFILLCOLOR = "ShapeFillColor",
	IMAGES = "Images",
	LOGOS = "Logos",
	TEXT = "Text",
	GRAPHICS = "Graphics",
	BRANDS = "Brands",
	LAYERS = "Layers",
	CAMPAIGNS = "Campaigns",
	RESIZE = "Resize",
	CANVASCOLOR = "CanvasColor",
	INSERTTEXT = "InsertText",
	STROKECOLOR = "StrokeColor",
	WIZARDIMAGES = "WizardImages",
}

export enum customStepperTitle {
	canvasStepperTitle = "Canvas",
	wizardImagesStepperTitle = "Images",
}

export const BASE_ITEMS = [
	{
		id: "templates",
		name: "Templates",
		stepperTitle: "Template",
		tabName: PanelType.TEMPLATES,
	},
	{
		id: "brands",
		name: "Brands",
		stepperTitle: "Brand",
		tabName: PanelType.BRANDS,
	},
	{
		id: "images",
		name: "Images",
		stepperTitle: "Smart image",
		tabName: PanelType.IMAGES,
	},
	{
		id: "logos",
		name: "Logos",
		stepperTitle: "",
		tabName: PanelType.LOGOS,
	},
	{
		id: "text",
		name: "Text",
		stepperTitle: "Edit text",
		tabName: PanelType.TEXT,
	},
	{
		id: "graphics",
		name: "Graphics",
		stepperTitle: "",
		tabName: PanelType.GRAPHICS,
	},

	{
		id: "layers",
		name: "Layers",
		stepperTitle: "",
		tabName: PanelType.LAYERS,
	},
	// {
	// 	id: "customize",
	// 	name: "Customize",
	// },
	// {
	// 	id: "elements",
	// 	name: "Elements",
	// },

	// {
	// 	id: "uploads",
	// 	name: "Uploads",
	// }
];
